export const SignUp = {
    // 证件真伪检测 / document spoof detection
    SpoofDetection: '真偽檢測',
    SpoofPass: '通過',
    SpoofRisk: '存在風險',
    SpoofTypeScreenRemark: '翻拍',
    SpoofTypePhotoCopy: '影印件',
    SpoofTypeTamper: 'PS篡改',
    SpoofTypeShortcut: '截屏',
    ParentIdDoc: '父親或母親的身份證明文件',
    HouseholdRegister: '戶口本',
    ParentConsentStatement: '監護人同意書',
};
